import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { Field, FieldArray } from 'formik';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import {
  RenderSelect,
  RenderTextField,
} from '../../../components/FormElements/FormikElements';
import { SmallToggleSwitch } from '../../../components/ToggleSwitch/ToggleSwitch';
import { MiniToggleSwitch } from '../../../components/ToggleSwitchSmall/ToggleSwitchSmall';
import { Box, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import FilterButton from '../../../components/FilterModal/FilterButton';
import FilterProductVariantsModal from '../../../components/FilterModal/FilterProductVariantsModal';
import { Button } from 'merchant-portal-components';
import _, { has } from 'lodash';
import { ga } from 'react-ga';
import SelectProductVariantsAndCombos from '../OfferEngineDetails/components/SelectProductVariantsAndCombos';
import { CustomizationContext } from '../../../utils/ClientCustomizationsProvider';
import { useContext } from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      minWidth: '100%',
    },
  },
}));
const Wrapper = styled.div`
  display: grid;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: ${(props) =>
    props.isLastItem ? 'none' : '2px solid #000000'};
  .mb25 {
    margin-bottom: 25px;
  }
`;
const ProductMain = styled.div`
  display: ${(props) => (props.isNotGrid ? 'block' : 'grid')};
  grid-template-columns: 250px 1fr 65px;
  grid-gap: 30px;
  padding: 10px 0px;
  border-bottom: 1px solid #ebebeb;

  .buttonDelete {
    background: none;
    border: 0px;
  }
  .MuiInputBase-input::placeholder {
    color: #000;
    opacity: 1;
  }
`;
const WrapperInner = styled.div`
  display: grid;
  align-items: center;
  margin-left: 30px;
`;
const Subtitle = styled.div`
  font-size: 21px;
  font-weight: 600;
  letter-spacing: 0.03px;
  color: #191818;
`;
const FullWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 65px;
  align-items: center;

  .formSection {
    display: grid;
  }
`;
const NoteText = styled.div`
  font-size: 14px;
  color: #191818;
  margin-bottom: 10px;
`;
const NoteHead = styled.div`
  font-size: 17px;
  color: #191818;
  font-weight: 600;
  margin-bottom: 5px;
`;
const NoteHeadNormal = styled.span`
  font-size: 17px;
  color: #191818;
  font-weight: normal;
`;
const SubHead = styled.div``;
const CopyButtonWrapper = styled.div`
  margin: 10px 12px;
  display: flex;
  justify-content: flex-end;
`;

const SegmentWrapper = styled.div`
  display: grid;
  grid-gap: 24px;
  margin-bottom: 20px;

  .react-select__control {
    background-color: white;
    border-radius: 6px;
  }

  .react-select__single-value {
    font-weight: 600;
    font-size: 14px;
  }

  .react-select__multi-value {
    background-color: #e6e6e6;
    border-radius: 15px;
    padding: 1px 3px;
    font-weight: 400;
    font-size: 14px;
  }
`;
const WrapperInside = styled.div`
  border-bottom: 1px solid #e1e1e1;
  padding-bottom: 10px;
  padding-top: 10px;

  .addProduct {
    background: none;
    border: 0px;
    font-size: 15px;
    font-weight: 600;
    margin-top: 20px;
    cursor: pointer;
  }
`;
const WrapperInsideHead = styled.div`
  padding-bottom: 10px;
  padding-top: 10px;
  padding-left: 15px;
  margin: 15px 0;
`;
const NoteTextBold = styled.div`
  font-size: 14px;
  color: #191818;
  margin-bottom: 10px;
  font-weight: 600;
`;
const TitleMain = styled.div`
  font-size: 21px;
  font-weight: 600;
  color: #191818;
`;
const SubtitleBlock = styled.div`
  margin-bottom: 15px;
`;
const NoteInside = styled.div`
  padding-left: 15px;
  font-size: 15px;
  font-weight: 600;
  margin-top: 10px;
  margin-bottom: 10px;
`;
const ActionBox = styled.div`
  display: flex;
  padding-left: 15px;
  max-width: 120px;
`;

const SubNoteInside = styled.div`
  padding-left: 15px;
  font-size: 12px;
  margin-top: -10px;
  margin-bottom: 10px;
`;
const WrapperInnerMain = styled.div`
  padding-left: 15px;
`;
const TierMain = styled.div`
  padding-left: 15px;
`;
const ErrorSpan = styled.div`
  color: red;
  font-size: 12px;
`;
const Requirement = ({
  title,
  values,
  setFieldValue,
  indexItem,
  subTitle,
  allProductVariants,
  isLastItemInTheCard,
  handleCopyRequirements,
  source,
}) => {
  const { isOfferPremiumClient } = useContext(CustomizationContext);
  const [productIndex, setProductIndex] = useState(0);
  const [comboIndex, setComboIndex] = useState(0);
  const [isAllProductsSelected, setIsAllProductsSelected] = useState(false);
  const initialProductPropertyIsEnabled = (() => {
    const requirements = values.conditionValue?.[indexItem]?.requirements ?? [];
    return requirements.some(
      (req) => req.product !== undefined || req.combo !== undefined
    );
  })();

  const [productPropertyIsEnabled, setProductPropertyIsEnabled] =
    useState(false);

  const handleToggleRequirement = useCallback(
    (checked) => {
      setProductPropertyIsEnabled(checked);
      const requirements = values.conditionValue[indexItem]?.requirements ?? [];
      if (checked) {
        if (requirements?.length === 0) {
          setProductIndex(0);
          setComboIndex(0);
          return;
        }

        const indexWithProductOrCombo = requirements.findIndex(
          (x) => x.product !== undefined || x.combo !== undefined
        );

        setProductIndex(
          indexWithProductOrCombo !== -1
            ? indexWithProductOrCombo
            : requirements?.length
        );
      } else {
        const filteredRequirements = requirements.filter(
          (req) => req.product === undefined && req.combo === undefined
        );

        if (filteredRequirements?.length !== requirements?.length) {
          setFieldValue(
            `conditionValue[${indexItem}].requirements`,
            filteredRequirements
          );
          setProductIndex(0);
        } else {
          setProductIndex(0);
        }
      }
    },
    [values.conditionValue, indexItem]
  );

  useEffect(() => {
    if (values.conditionValue[indexItem]?.requirements.length > 0) {
      setProductPropertyIsEnabled(true);
    } else {
      setProductPropertyIsEnabled(false);
    }
  }, []);

  const [posMappingStringValue, setPosMappingStringValue] = useState('');
  const [posMappingStringValueCombos, setPosMappingStringValueCombos] =
    useState('');
  const isSourcePOS = !['mobile', 'web'].includes(source);

  useEffect(() => {
    if (
      values.conditionValue[indexItem]?.requirements?.length > 0 &&
      !['web', 'mobile'].includes(values.conditionValue[indexItem]?.source)
    ) {
      let posMappingString = JSON.stringify(
        values.conditionValue[indexItem]?.requirements[
          productIndex
        ]?.product?.products.map((pro) => pro.product_id)
      );
      posMappingString = posMappingString?.substring(
        1,
        posMappingString?.length - 1
      );
      posMappingString = posMappingString?.replaceAll('"', '');
      setPosMappingStringValue(posMappingString);
      // initialize combos pos value
      if (isOfferPremiumClient) {
        let posMappingStringCombos = JSON.stringify(
          values.conditionValue[indexItem]?.requirements[
            productIndex
          ]?.combo?.combos?.map((combo) => combo.combo_id)
        );
        posMappingStringCombos = posMappingStringCombos?.substring(
          1,
          posMappingStringCombos.length - 1
        );
        posMappingStringCombos = posMappingStringCombos?.replaceAll('"', '');
        setPosMappingStringValueCombos(posMappingStringCombos);
      }
    }
  }, [indexItem, productIndex]);
  useEffect(() => {
    let count = 0;
    allProductVariants?.forEach((product) => {
      if (product.prices?.length > 0) {
        product.prices.forEach((variant) => count++);
      } else {
        count++;
      }
    });
    const mappedProductVariants =
      values.conditionValue[indexItem]?.requirements[productIndex]?.product
        ?.products;
    if (count === mappedProductVariants?.length) {
      setIsAllProductsSelected(true);
    } else {
      setIsAllProductsSelected(false);
    }
  }, [
    values.conditionValue[indexItem]?.requirements[productIndex]?.product
      ?.products,
    allProductVariants,
  ]);
  const handleChangePOSIDs = (e, setFieldValue, indexItem, productIndex) => {
    const field = e.target.name;
    const value = e.target.value;
    let formattedFiledValue = [];
    let filedValue = value.split(',');
    if (field.includes('combos') && isOfferPremiumClient) {
      filedValue.forEach((item) => {
        formattedFiledValue.push({ combo_id: item });
      });
      const hasConditionField =
        values.conditionValue[indexItem]?.requirements[productIndex]?.combo
          ?.condition;
      if (
        !hasConditionField &&
        values.conditionValue[indexItem]?.requirements[productIndex + 1]?.combo
          ?.combos?.length > 0
      ) {
        let conditionField = `conditionValue[${indexItem}].requirements[${
          productIndex + 1
        }].combo.condition`;
        setFieldValue(conditionField, 'OR');
      }
      setFieldValue(field, formattedFiledValue);
      setPosMappingStringValueCombos(value);
    } else {
      filedValue.forEach((item) => {
        formattedFiledValue.push({ product_id: item });
      });
      const hasConditionField =
        values.conditionValue[indexItem]?.requirements[productIndex]?.product
          ?.condition;

      if (
        !hasConditionField &&
        values.conditionValue[indexItem]?.requirements[productIndex]?.product
          ?.products?.length > 0
      ) {
        let conditionField = `conditionValue[${indexItem}].requirements[${productIndex}].product.condition`;
        setFieldValue(conditionField, 'AND');
      }
      setFieldValue(field, formattedFiledValue);
      setPosMappingStringValue(value);
    }
  };

  const isProductSelected =
    values.conditionValue[indexItem]?.requirements[productIndex]?.product
      ?.products?.length > 0;
  const isComboSelected =
    isOfferPremiumClient &&
    values.conditionValue[indexItem]?.requirements[productIndex]?.combo?.combos
      ?.length > 0;
  console.log('productPropertyIsEnabled', productPropertyIsEnabled);
  return (
    <Wrapper isLastItem={isLastItemInTheCard}>
      <FullWrapper>
        <div>
          <TitleMain>{title}</TitleMain>
          <SubtitleBlock>{subTitle}</SubtitleBlock>
        </div>
      </FullWrapper>
      <WrapperInside style={{ marginTop: '20px' }}>
        <FullWrapper>
          <div className='formSection'>
            <NoteHead>Purchase requirements</NoteHead>
            <NoteText>
              {values.conditionValue[indexItem]?.source === 'quickservice'
                ? 'Customer must purchase qualifying products to redeem this offer.'
                : 'Customer must purchase qualifying menu items to redeem this offer.'}
            </NoteText>
          </div>
          <div>
            <MiniToggleSwitch
              name={'product'}
              label=''
              checked={productPropertyIsEnabled}
              onChange={(e) => {
                handleToggleRequirement(e.target.checked);
              }}
            ></MiniToggleSwitch>
          </div>
        </FullWrapper>

        {productPropertyIsEnabled &&
          ['mobile', 'web'].includes(
            values.conditionValue[indexItem]?.source
          ) && (
            <>
              {!isSourcePOS && (
                <CopyButtonWrapper>
                  <Button
                    onClick={() =>
                      handleCopyRequirements(
                        title === 'Web' ? 'mobile' : 'web',
                        indexItem
                      )
                    }
                  >
                    {values.conditionValue[indexItem]?.source === 'web'
                      ? 'Copy From Mobile'
                      : 'Copy From Web'}
                  </Button>
                </CopyButtonWrapper>
              )}

              <SelectProductVariantsAndCombos
                values={values}
                setFieldValue={setFieldValue}
                indexItem={indexItem}
                productIndex={productIndex}
                isEmptyAcceptable={false}
                isFromRequirement={true}
                isEmptyEqualAll={false}
              />
            </>
          )}
        {isSourcePOS && productPropertyIsEnabled && (
          <>
            <TextField
              multiline
              placeholder='Type POS IDs'
              name={`conditionValue[${indexItem}].requirements[${productIndex}].product.products`}
              value={posMappingStringValue}
              onChange={(e) =>
                handleChangePOSIDs(e, setFieldValue, indexItem, productIndex)
              }
              variant='outlined'
              style={{ width: '100%' }}
            />
            {values.conditionValue[indexItem]?.requirements[productIndex]
              ?.product?.products?.length === 0 && (
              <ErrorSpan>Required</ErrorSpan>
            )}
          </>
        )}
        {isSourcePOS &&
          productPropertyIsEnabled &&
          values.conditionValue?.[indexItem]?.source === 'quickservice' && (
            <Box
              sx={
                !isOfferPremiumClient
                  ? {
                      pointerEvents: 'none',
                      opacity: 0.5,
                      filter: 'grayscale(0.5)',
                      '*': {
                        pointerEvents: 'none',
                      },
                    }
                  : {}
              }
            >
              <FullWrapper style={{ marginTop: '20px' }}>
                <div className='formSection'>
                  <NoteText>
                    Customer must purchase qualifying combos to redeem this
                    offer.{' '}
                    {!isOfferPremiumClient && <span>(Premium Offer)</span>}
                  </NoteText>
                </div>
              </FullWrapper>
              <TextField
                multiline
                placeholder='Type POS IDs'
                name={`conditionValue[${indexItem}].requirements[${productIndex}].combo.combos`}
                value={posMappingStringValueCombos}
                onChange={(e) =>
                  handleChangePOSIDs(e, setFieldValue, indexItem, productIndex)
                }
                variant='outlined'
                style={{ width: '100%' }}
              />
              {values.conditionValue[indexItem]?.requirements[productIndex]
                ?.product?.combos?.length === 0 && (
                <ErrorSpan>Required</ErrorSpan>
              )}
            </Box>
          )}
        {productPropertyIsEnabled && (isProductSelected || isComboSelected) && (
          <WrapperInsideHead>
            <NoteTextBold>
              * How many of the required{' '}
              {isProductSelected && isComboSelected
                ? `products ${isOfferPremiumClient ? 'and combos' : ''}`
                : isProductSelected
                ? 'products'
                : 'combos'}{' '}
              does the customer need to purchase to be eligible for the offer?
            </NoteTextBold>

            <Box display='flex' gap={4}>
              {(isProductSelected ||
                (isComboSelected && isOfferPremiumClient)) && (
                <RadioGroup
                  aria-labelledby='radio-condition-group-label'
                  value={
                    values.conditionValue[indexItem]?.requirements[productIndex]
                      ?.product?.condition ||
                    values.conditionValue[indexItem]?.requirements[productIndex]
                      ?.combo?.condition
                  }
                  id='radio-condition-group'
                  name='radio-condition-group'
                  onChange={(event) => {
                    if (isProductSelected) {
                      setFieldValue(
                        `conditionValue[${indexItem}].requirements[${productIndex}].product.condition`,
                        event.target.value
                      );
                    }
                    if (isComboSelected && isOfferPremiumClient) {
                      setFieldValue(
                        `conditionValue[${indexItem}].requirements[${productIndex}].combo.condition`,
                        event.target.value
                      );
                    }
                  }}
                >
                  <Box display='flex' flexDirection='column' gap={1}>
                    <FormControlLabel
                      value='AND'
                      control={<Radio />}
                      label='All required'
                    />
                    <FormControlLabel
                      value='OR'
                      control={<Radio />}
                      label='At least one required'
                    />
                  </Box>
                </RadioGroup>
              )}
            </Box>
          </WrapperInsideHead>
        )}
      </WrapperInside>
    </Wrapper>
  );
};
export default Requirement;
